var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { getOfflineSourceRegisterData, getOfflineTrackingRegisterData, } from "@jti/fe-common";
const MULTIOPTION_SEPARATOR = "--";
const ACCEPTED_VALUE = "true";
/**
 * Transforms registration form purposes into CAS consent structure.
 * Each purpose value is expected to be a string in format "true", "false", and double dash separated values "true--true",
 * where the first value indicates if the consent is accepted and the second value
 * indicates if it's a one_off consent.
 *
 * The function is backward compatible and will work with single values (e.g., "true" or "false")
 * where only the accepted status is provided without the one_off flag.
 *
 * @param {Object} params - The parameters object
 * @param {Record<string, string | boolean>} params.purposes - Object containing consent purposes where key is the consent ID and value is the consent state
 * @returns {ConsentType[]} Array of transformed consent objects with id, accepted status, and optional one_off flag
 */
export const transformToCasConsents = ({ purposes }) => {
    if (!purposes)
        return [];
    return Object.entries(purposes).map(([key, value]) => {
        const valueString = value.toString();
        const [firstValue, secondValue] = valueString.split(MULTIOPTION_SEPARATOR);
        const accepted = firstValue === ACCEPTED_VALUE;
        const one_off = secondValue === ACCEPTED_VALUE;
        return Object.assign({ id: key, accepted }, (secondValue && { one_off }));
    });
};
export const transformToCasUser = (data, preferredLanguage) => {
    const { telephone, custom_attributes = {}, email = "", gender } = data, registerData = __rest(data, ["telephone", "custom_attributes", "email", "gender"]);
    return Object.assign(Object.assign(Object.assign({}, registerData), { consents: transformToCasConsents(data), email, phone: telephone, custom_attributes: Object.assign(Object.assign({}, custom_attributes), { preferredLanguage }), source: getOfflineSourceRegisterData(), tracking: getOfflineTrackingRegisterData() }), (gender && { gender: gender.value }));
};
